// extracted by mini-css-extract-plugin
export default {"page":"Blog_page__a1h8b","hero":"Blog_hero__UyyRQ","label":"Blog_label__TflKj"};